export class User {
    constructor(
      public id: string,
      public name: string,
      public email: string,
      public initialSetup: boolean,
      public avatarId: string,
      public country: string,
      public statusMessage: string
    ) { }
  }